var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.3333C15 20.7145 15.2897 20.121 15.8055 19.6834C16.3212 19.2458 17.0207 19 17.75 19H27C27.7293 19 28.4288 19.2458 28.9445 19.6834C30.0844 20.6506 30.5 21 30.75 21.3333V30.6667C30.75 31.2855 29.4603 31.879 28.9445 32.3166C28.4288 32.7542 27.7293 33 27 33H17.75C17.0207 33 16.3212 32.7542 15.8055 32.3166C15.2897 31.879 15 31.2855 15 30.6667V21.3333ZM32.2604 22.6237C32.032 22.7205 31.8399 22.8693 31.7056 23.0536C31.5713 23.2378 31.5001 23.4501 31.5 23.6667V28.3333C31.5001 28.5499 31.5713 28.7622 31.7056 28.9464C31.8399 29.1307 32.032 29.2795 32.2604 29.3763L35.0104 30.543C35.22 30.6319 35.4528 30.6738 35.6869 30.6649C35.9209 30.6559 36.1484 30.5964 36.3477 30.4919C36.547 30.3874 36.7116 30.2414 36.8257 30.0679C36.9399 29.8943 36.9999 29.6988 37 29.5V22.5C36.9999 22.3012 36.9399 22.1057 36.8257 21.9322C36.7116 21.7586 36.547 21.6126 36.3477 21.5081C36.1484 21.4036 35.9209 21.3441 35.6869 21.3351C35.4528 21.3262 35.22 21.3681 35.0104 21.457L32.2604 22.6237Z",
    fill: "#3485C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/VideoOn.f7d11987d7d3caa6ffb48fc52d9fb1b9.svg";
export { ForwardRef as ReactComponent };